<template>
  <div class="mx-auto fixed-width-form">
    <legend>Отправка заказов</legend>
    <form @submit.prevent="dispatch">
      <div class="form-group row">
        <div class="col-md-6">
          <label>Объезд</label>
          <v-select :disabled="!isToursExist" :options="tours" label="Name" v-model="currentTour">
            <template #search="{attributes, events}">
              <input
                :required="!currentTour"
                class="vs__search"
                v-bind="attributes"
                v-on="events"
                v-on:keydown.enter.prevent
              />
            </template>
          </v-select>

        </div>
        <div class="col-md-6">
          <label>Дата отправки</label>
          <date-picker :first-day-of-week="1" :input-attr="{required: true}" class="w-100"
                       lang="ru"
                       v-model="dispatchDate" valueType="format"></date-picker>
        </div>
      </div>
      <div class="form-group">
        <div class="input-group">
          <input class="form-control" placeholder="Номер сферы" ref="inputSferaNumber" required
                 type="number" v-model="sferaNumber">
          <div class="input-group-append">
            <button class="btn btn-outline-secondary" type="submit">Отправить</button>
          </div>
        </div>
      </div>
    </form>
    <table class="table table-striped table-sm table-hover">
      <thead>
      <tr>
        <th>Объезд</th>
        <th class="text-center">На день</th>
        <th class="text-center">Готово</th>
        <th class="text-center">Отправлен</th>
        <th width="120"></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="tour in stats">
        <td>{{tour.TourName}}</td>
        <td class="text-center">{{(tour.CountByStatus.ready || 0) + (tour.CountByStatus.dispatch ||
          0)}}
        </td>
        <td class="text-center">{{tour.CountByStatus.ready}}</td>
        <td class="text-center">{{tour.CountByStatus.dispatch}}</td>
        <td>
          <button @click.prevent="showLeft" class="btn btn-sm btn-outline-secondary btn-block"
                  type="button">Остаток {{tour.left}}
          </button>
        </td>
      </tr>
      </tbody>
    </table>
    <modals-container/>
  </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import _ from 'lodash';
import { get, post } from '@/admin/services/api/http-utils';
import LeftOrders from '@/admin/components/LeftOrders.vue';

const url = `${process.env.VUE_APP_API_HOST}admin/dispatch`;


export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      tours: [],
      currentTour: null,
      dispatchDate: null,
      sferaNumber: null,
      stats: [],
    };
  },
  async mounted() {
    await this.fetchTours();
  },
  watch: {
    dispatchDate() {
      this.fetchStats();
    },
  },
  computed: {
    isToursExist() {
      return this.tours.length;
    },
  },
  methods: {
    async fetchTours() {
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/tour`);
      this.tours = data;
    },
    async dispatch() {
      try {
        await post(`${url}/partner-dispatch-order`, {
          tourId: this.currentTour.Id,
          dispatchDate: this.dispatchDate,
          sferaNumber: this.sferaNumber,
        });
        this.$toasted.show(`Заказ ${this.sferaNumber} отправлен!`, { type: 'success' });
        this.sferaNumber = null;
        this.$refs.inputSferaNumber.focus();
        _.debounce(this.fetchStats, 300);
      } catch (error) {
        if (error.response && error.response.data) {
          this.$toasted.show(error.response.data, { type: 'error' });
        } else {
          this.$toasted.show('Неизвестная ошибка', { type: 'error' });
        }
      }
    },
    async fetchStats() {
      if (!this.dispatchDate) {
        this.stats = [];
        return;
      }
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/dispatch/dispatch-stats-by-date/${this.dispatchDate}`);
      this.stats = data;
    },

    showLeft() {
      this.$modal.show(LeftOrders, {
        date: this.dispatchDate,
      }, {
        // maxWidth: 900,
        width: 900,
        height: '90%',
        pivotY: 0.2,
      });
    },
  },
};
</script>
